/**
 * AlmadarPostLearningFromInterruptionsENAlmadarPostLearningFromInterruptionsENPage
 *
 * Page component for AlmadarPostLearningFromInterruptionsENAlmadarPostLearningFromInterruptionsENPage
 * Path: /blog/learning-from-interruptions
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { AlmadarPostLearningFromInterruptionsENPostPageView as __AlmadarPostLearningFromInterruptionsENPostPageView } from '@/components/traits/AlmadarPostLearningFromInterruptionsENPostPageView';
import { AlmadarPostLearningFromInterruptionsENPostAnalyticsView as __AlmadarPostLearningFromInterruptionsENPostAnalyticsView } from '@/components/traits/AlmadarPostLearningFromInterruptionsENPostAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';

interface AlmadarPostLearningFromInterruptionsENAlmadarPostLearningFromInterruptionsENPageProps {
  // Add any page-level props here
}

export function AlmadarPostLearningFromInterruptionsENAlmadarPostLearningFromInterruptionsENPage(_props: AlmadarPostLearningFromInterruptionsENAlmadarPostLearningFromInterruptionsENPageProps) {
  const __navState = (useLocation().state ?? {}) as EventPayload;

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__AlmadarPostLearningFromInterruptionsENPostPageView config={{ initPayload: __navState }} />
          <__AlmadarPostLearningFromInterruptionsENPostAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default AlmadarPostLearningFromInterruptionsENAlmadarPostLearningFromInterruptionsENPage;
